import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {MessageService} from "primeng/api";
import {CrCustomerRelatedPersonWidgetStyle} from "./uiStyle/cr-customer-related-person-widget-style";
import {CustomerDto} from "../../../model/dto/entity/customer.dto";
import {CustomerRelatedPersonDto} from "../../../model/dto/entity/customer-related-person.dto";
import {DtoDetail} from "../../../../../core/shared/dto/dto.detail";
import {Observable, Subscription} from "rxjs";
import {MvsObjectNavigationService} from "../../../../../core/shared/navigation/mvs-object-navigation.service";
import {CustomerService} from "../../../service/api/customer.service";
import {MvsUiObjectService} from "../../../../../core/shared/object/service/mvs-ui-object.service";
import {MvsCoreService} from "../../../../../core/shared/service/mvs-core.service";
import {MvsConfigService} from "../../../../../core/shared/config/mvs-config.service";
import {DtoList} from "../../../../../core/shared/dto/dto.list";
import {ObjectRequestComplex} from "../../../../../core/shared/dto/object/request/object-request-complex";
import {ObjectRequestComplexNode} from "../../../../../core/shared/dto/object/request/object-request-complex-node";
import {ObjectRequestRelation} from "../../../../../core/shared/dto/object/request/object-request-relation";
import {
    ObjectRequestComplexRelationBindingEnum
} from "../../../../../core/shared/dto/object/request/object-request-complex-relation-binding.enum";
import {ObjectRequestList} from "../../../../../core/shared/dto/object/request/object-request-list";
import {FilterCriteria} from "../../../../../core/shared/filter/api/filter.criteria";
import {ObjectIdentifier} from "../../../../../core/shared/basic/object-identifier";


@Component({
    selector: 'mvs-cr-customer-related-persons',
    templateUrl: './cr-customer-related-persons.component.html',
    styleUrls: ['./cr-customer-related-persons.component.scss'],
    standalone: false
})
export class CrCustomerRelatedPersonsComponent
    implements OnInit, OnDestroy, OnChanges {


    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized
    value: boolean;
    IsSelectAll : boolean;
    splitButtonItems: any;
    @Input() customerDto: CustomerDto;
    @Output() selectedRelatedPersonsChanged = new EventEmitter<CrCustomerRelatedPersonWidgetStyle>();


    // customerRelatedPersons: any[];
    selectedPersonWidgetStyle: CrCustomerRelatedPersonWidgetStyle;
    customerRelatedPersons: CustomerRelatedPersonDto[];
    selectedRelatedPerson: DtoDetail;
    broadcastSubscription: Subscription;

    constructor(public messageService: MessageService,
                protected navigationService: MvsObjectNavigationService,
                protected customerService:CustomerService,
                protected objectService:MvsUiObjectService,
                protected coreService: MvsCoreService,
                protected configService: MvsConfigService) {
    }

    ngOnInit(): void {
        this.initComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.refreshInternal();

    }

    refreshInternal() {

        this.getCustomerRelatedPersons(this.customerDto.id).subscribe(value => {
            this.customerRelatedPersons = value.entries[0]['relatedPersonCustomers'];
            this.prepareUiData(this.customerRelatedPersons);
            this.selectedPersonWidgetStyle = new CrCustomerRelatedPersonWidgetStyle(this.configService, this.customerDto, []);
            this.initialized = true;

        });
    }

    prepareUiData(relatedPersons: CustomerRelatedPersonDto[]) : CustomerRelatedPersonDto[]  {
        if (relatedPersons) {
            for (const item of relatedPersons) {
                let icon: string = '';

                // preparing ui names since we cant add icons to label in split buttons

                if (item['sameHousehold']) {
                    icon = ' <i class="fa-sharp fa-solid fa-house mx-2"></i>'
                }
                const fullName = item.personDto.firstName + ' ' + item.personDto.lastName;

                // TODO: Create union type
                item['uiCustomerName'] = fullName + ' (' + item.relatedPersonTypeDto.name + ')' + icon;
            }
        }
        return relatedPersons;

    }

    getCustomerRelatedPersons(customerId: number): Observable<DtoList> {
        const complexSelection = ObjectRequestComplex.build(false, false,
            //ObjectRequestComplexNode.createRelationNode("emergencyContacts",ObjectRequestRelation.createJoin("+emergencyContacts")),
            ObjectRequestComplexNode.createRelationNode("relatedPersonCustomers", ObjectRequestRelation.createJoin("+relatedPersonCustomers"))
                .addNodes(ObjectRequestComplexNode.createSimpleAttributeNode("person")
                    .addNodes(ObjectRequestComplexNode.createRelationNode("relatedCustomer",ObjectRequestRelation.createJoinWithBindingType("cr.Customer#person", ObjectRequestComplexRelationBindingEnum.LATEST))
                    ))
                .addNodes(ObjectRequestComplexNode.createSimpleAttributeNode('relatedPersonType'))
        );

        const objectRequestList = ObjectRequestList.createComplexRequestList(
            true,
            complexSelection,
            [FilterCriteria.create('id', FilterCriteria.cOperatorEqual , customerId)],
            [],
            null,
            null)

        return this.customerService.list(objectRequestList);
    }



    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["customerDto"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {
        if (this.broadcastSubscription) {
            this.broadcastSubscription.unsubscribe();
        }
    }

    handleSelectRelatedPerson(person:CustomerRelatedPersonDto, event: MouseEvent){

        if (event.ctrlKey || event.metaKey || event.button == 1){
            //ctrl is pressed, open customer in new tab
            this.handleNavigation(person.personDto["relatedCustomer"].id);

        } else {

            person['__selected'] = !person['__selected'];
            const customerId: number = person.personDto['relatedCustomer'].id;

            if(!customerId){
                return;
            }

            if (person['__selected'] && customerId) {
                this.selectedPersonWidgetStyle.addRelatedPerson(person,customerId);
            } else {
                this.selectedPersonWidgetStyle.removeRelatedPerson(person);
            }

            person['__style'] = this.selectedPersonWidgetStyle.getStyleObjectForAvatar(person);

            this.changeArrayReference(person);
            this.selectedRelatedPersonsChanged.emit(this.selectedPersonWidgetStyle);
        }

    }

    changeArrayReference(person: CustomerRelatedPersonDto){
        const index = this.customerRelatedPersons.findIndex(item => item == person);
        const newPerson = structuredClone(person);
        if(index > -1) {
            this.customerRelatedPersons.splice(index,1,newPerson);
        }
    }

    onAllAvatarSelect() {
        this.IsSelectAll = !this.IsSelectAll ;
        for (const person of this.customerRelatedPersons) {
            this.handleSelectRelatedPerson(person, null);
        }
    }

    handleButtonClick(person:CustomerRelatedPersonDto): void {

        this.splitButtonItems = [];
        const customerId = person.personDto['relatedCustomer'].id;

        this.getCustomerRelatedPersons(customerId).subscribe(res => {
            const records = res.entries[0]['relatedPersonCustomers'];
            const buttonItems = [];
            this.prepareUiData(records);

            if (records) {
                for (let item of records) {
                    const fullName = item.personDto.firstName + ' ' + item.personDto.lastName + ' (' + item.relatedPersonTypeDto.name + ')';

                    const button = {
                        label: fullName,
                        id: item.personDto["relatedCustomer"].id,
                        icon: 'fa-regular fa-arrow-up-right-from-square text-color-secondary split-button-menu-icon',
                        iconPos: 'right',
                        command:() => this.handleNavigation(button.id)
                    }
                    buttonItems.push(button);
                }
            } else {
                const button = { label: 'No related persons found!' };
                buttonItems.push(button);

            }
            this.splitButtonItems = buttonItems;
        });
    }

    handleNavigation(customerId: number) {
        this.navigationService.handleObjectNavigation(new ObjectIdentifier('cr.Customer', customerId),null, {openNewTab: true});
    }

}
